import React from "react";

const ObjectivesYEI = () => {
  const objectivesData = [
    {
      title: "Course Objectives:",
      items: [
        "Provide in-depth knowledge of international relations theories and diplomatic practices.",
        "Develop advanced negotiation, mediation, and conflict resolution skills.",
        "Explore the role of diplomacy in addressing global challenges, including climate change and migration.",
        "Foster cross-cultural communication and collaboration skills essential for international relations.",
        "Equip participants to evaluate and shape foreign policies and global strategies.",
      ],
      color: "text-green-600",
    },
    {
      title: "Course Outcomes:",
      items: [
        "Demonstrate a nuanced understanding of global political systems and diplomatic frameworks.",
        "Apply advanced diplomatic strategies to resolve international challenges.",
        "Exhibit proficiency in negotiation, mediation, and conflict resolution.",
        "Critically analyse global trends and propose innovative solutions for international cooperation.",
        "Communicate effectively in multicultural environments, leveraging cultural intelligence and strategic foresight.",
      ],
      color: "text-purple-600",
    },
  ];
  return (
    <div className="my-10 " id="objectives">
      <div className="max-w-6xl mx-auto bg-sdbodywhite bg-opacity-70 shadow-lg rounded-lg p-8">

        <div className="md:flex md:gap-8 space-y-5 md:space-y-0">
          {objectivesData.map((section, index) => (
            <div key={index} className="md:w-1/2">
              <h3
                className={`text-lg md:text-2xl font-semibold mb-4 ${section.color}`}
              >
                {section.title}
              </h3>
              <ul className="space-y-4 list-disc list-inside">
                {section.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-4">
                    <img
                      src="/image-fix/pointers/inspiration-svgrepo-com.svg"
                      alt="icon"
                      className="w-8 h-8 mt-1"
                    />
                    <span className="text-base">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ObjectivesYEI;
